import type { Components, Theme } from "@mui/material";

export const typographyTheme: Components<Theme>["MuiTypography"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      "& a": {
        color: theme.palette.info.main,
        textDecoration: "none",
      },
    }),
  },
};
